__webpack_require__.p = "/app-protocol-demo/";